import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import Video from 'main/Contact/Video'
import Form from 'main/Contact/Form'

interface Datas {
  slug: string
  title: string
}

const s = {
  container: `w-full h-fit-content pt-24 pb-48 section`,
  wrapper: `wrapper`,

  group: `w-fit-content h-fit-content`,
  title: `-mt-4 mb-0`,
  line: `w-full h-1.5 mt-0 mb-16 bg-impred`,

  flex: `flex flex-col`,
}

const Contact = () => {
  const datas = useStaticQuery(graphql`
    query {
      flamelinkContactContent {
        slug
        title
        alt
        width
        height
        video {
          url
        }
      }
    }
  `)

  const { slug, title } = datas.flamelinkContactContent as Datas

  return (
    <section className={s.container} id={slug}>
      <div className={s.wrapper}>
        <div className={s.group}>
          <h2 className={s.title}>{title}</h2>
          <div className={s.line} />
        </div>

        <div className={s.flex}>
          <Video datas={datas} />
          <Form />
        </div>
      </div>
    </section>
  )
}

export default Contact
